import { Button } from '@mui/material';
import {
  getGridDateOperators,
  getGridStringOperators,
  GridColDef,
} from '@mui/x-data-grid-pro';
import moment from 'moment';

import { IcIncomingCall } from '@/assets/images';
import { excludeValues } from '@/components/DataGrid/utils';
import { DATE_TIME_FORMAT_WITH_SECONDS } from '@/config';
import { ICall } from '@/models';
import { formatPersonName } from '@/utils';

const callDirection = (): Partial<GridColDef> => ({
  renderCell: () => <IcIncomingCall style={{ marginTop: '6px' }} />,
  filterable: false,
});
const id = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.id || '-',
});
const phoneNumber = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.phoneNumber || '-',
});
const externalCallId = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.externalCallId || '-',
});
const extension = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row?.extension || '-',
  filterOperators: getGridStringOperators().filter(
    excludeValues(['isAnyOf', 'isNotEmpty', 'isEmpty']),
  ),
});
const createdAt = (): Partial<GridColDef> => ({
  renderCell: (params) =>
    moment(params.row.createdAt).format(DATE_TIME_FORMAT_WITH_SECONDS) || '-',
  filterOperators: getGridDateOperators(true).filter(
    excludeValues(['isNotEmpty', 'isEmpty']),
  ),
});
const callResult = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    return params.row.missed ? 'Missed' : 'Handled';
  },
  filterOperators: getGridStringOperators().filter(
    excludeValues([
      'isAnyOf',
      'isNotEmpty',
      'isEmpty',
      'doesNotContain',
      'doesNotEqual',
      'endsWith',
    ]),
  ),
});
const handledBy = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    if (params.row.missed) {
      return '';
    }
    if (!params.row.handledBy) {
      return '';
    }
    return formatPersonName(params.row.handledBy);
  },
});
const disposition = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.disposition || '-',
});

const actions = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: ICall) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => {
    return (
      <Button
        onClick={(e) => {
          e.stopPropagation();
          openMenu?.(e, params.row);
        }}
      >
        View
      </Button>
    );
  },
});

export const callRecordsCols = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: ICall) => void,
) => {
  return {
    callDirection,
    id,
    phoneNumber,
    externalCallId,
    extension,
    createdAt,
    callResult,
    handledBy,
    disposition,
    actions: () => actions(openMenu),
  };
};
